import { render, staticRenderFns } from "./suggestionsListCreateDialog.vue.html?vue&type=template&id=444f2fe6&"
import script from "./suggestionsListCreateDialog.ts?vue&type=script&lang=ts&"
export * from "./suggestionsListCreateDialog.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports